import React, { useRef, useEffect, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";

const MapComponent = ({ selectedShop }) => {
  const [infoWindowData, setInfoWindowData] = useState(null);

  const mapRef = useRef(null); // Reference to the map instance
  const mapContainerStyle = {
    width: "100%",
    height: "600px",
  };

  const center = {
    lat: 21.056620358163823, // Default center (change to your preferred coordinates)
    lng: 105.7843775768462,
  };

  // Pan map to the selected shop when it changes
  useEffect(() => {
    if (selectedShop && mapRef.current) {
      console.log(mapRef.current);
      mapRef.current.panTo(selectedShop.location); // Center the map on the selected shop
    }
  }, [selectedShop]);

  return (
    <LoadScript googleMapsApiKey="AIzaSyDPXtUJChGeiuEl-tN-MkD9zMgtzBNIaUY">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={16}
        center={selectedShop || center}
        onLoad={(map) => (mapRef.current = map)} // Set the map reference on load
      >
        {selectedShop && (
          <>
            <Marker
              position={selectedShop.location}
              onClick={() => setInfoWindowData(selectedShop)}
              icon={{
                url: "/images/cer/img_title_collection_spec.webp", // Replace with your custom icon's path
                scaledSize: new window.google.maps.Size(40, 40), // Adjust size as needed
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(20, 40), // Adjust the anchor point
              }}
            />
            {infoWindowData && (
              <InfoWindow
                position={infoWindowData.location}
                onCloseClick={() => setInfoWindowData(null)}
              >
                <div>
                  <h4>{infoWindowData.name}</h4>
                  <p>{infoWindowData.address}</p>
                </div>
              </InfoWindow>
            )}
          </>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapComponent;
